/**
 * Created by tomers on 5/6/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var SkillLoadBalanceView = require("user-management-views/skills/SkillLoadBalanceView");
    var SkillLoadBalanceSectionModel = require("user-management-models/SkillLoadBalanceSectionModel");
    var LoadBalanceCollection = require("user-management-collections/LoadBalanceCollection");

    var TOTAL_SCORE = 100;

    var SkillLoadBalanceController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillLoadBalanceController = Marionette.Controller.extend({

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                LEUserManagement.logger.info("initializing", "SkillLoadBalanceController:initialize");
                this.loadBalanceData = options.loadBalanceData || [];
                this.agentGroupsCollection = options.agentGroupsCollection;
                this.container = options.container;
                this.channel = options.channel;
                this.priority = options.priority;
                this._bindEvents();
            },

            addLoadBalance: function(routingConfiguration) {
                this._addAgentGroupSection(routingConfiguration);
            },

            createLoadBalance: function() {
                if(!_.isEmpty(this.loadBalanceData)) {
                    this.loadBalanceCollection = new LoadBalanceCollection(this.loadBalanceData);
                    this.loadBalanceData = [];
                } else {
                    this.loadBalanceCollection = new LoadBalanceCollection();
                    this._addAgentGroupSection();
                }
                this.skillLoadBalanceView = new SkillLoadBalanceView({el: this.container, collection: this.loadBalanceCollection, agentGroupsCollection: this.agentGroupsCollection, channel: this.channel});
                this.container.append(this.skillLoadBalanceView.render().$el);
            },

            deleteLoadBalance: function(options) {
                options = options || {};
                if(options.model) {
                    this.loadBalanceCollection.remove(options.model);
                    this.channel.trigger("loadBalance:model:changed", {valueIsChanged: true});
                }
                this._loadBalanceSplitPercentageChanged();
            },

            deleteLoadBalancePriority: function() {
                this.loadBalanceCollection.reset([]);
                this.channel.trigger("loadBalance:model:changed", {valueIsChanged: true});
            },

            validateSaveEnabled: function() {
                var isValid = true;
                _.find(this.loadBalanceCollection.models, function(model) {
                    if(!model.validateSaveEnabled()) {
                        isValid = false;
                        return true;
                    }
                }, this);
                return isValid;
            },

            getTotalScore: function() {
                var score = 0;
                if (!_.isUndefined(this.loadBalanceCollection)){
                    _.each(this.loadBalanceCollection.models, function(model) {
                        var splitPercentage = model.getSplitPercentage();
                        if ("" !== splitPercentage) {
                            score += parseInt(splitPercentage, 10);
                        }
                    }, this);
                }
                return score;
            },

            getViewByModel: function(model) {
                return this.skillLoadBalanceView.children.findByModel(model);
            },

            getLoadBalanceCollection: function() {
                return this.loadBalanceCollection;
            },

            _getAgentGroupsDuplicate: function() {
                var agentGroupsSelected = {};
                this.loadBalanceCollection.each(function(model) {
                    if(agentGroupsSelected[model.getAgentGroupId()] === undefined) {
                        agentGroupsSelected[model.getAgentGroupId()] = 0;
                    } else {
                        agentGroupsSelected[model.getAgentGroupId()] += 1;
                    }
                });
                var agentGroupsDuplicate = [];
                _.each(agentGroupsSelected, function(value, key) {
                    if(value > 0) {
                        agentGroupsDuplicate.push(key);
                    }
                }, this);
                return agentGroupsDuplicate;
            },

            _loadBalanceScoreChanged: function() {
                this.channel.trigger("loadBalance:change:total", this.getTotalScore());
            },

            _loadBalanceSplitPercentageChanged: function() {
                this._loadBalanceScoreChanged();
                this._loadBalanceChanged();
            },

            _loadBalanceAgentGroupIdChanged: function() {
                this._loadBalanceChanged();
            },

            _loadBalanceChanged: function() {
                var data = this._getLoadBalanceData() || [];
                this.channel.trigger("loadBalance:data", data);
            },

            _getLoadBalanceData: function() {
                var loadBalanceData = [];
                if (this.loadBalanceCollection) {
                    loadBalanceData = this.loadBalanceCollection.toJSON();
                }
                return loadBalanceData;
            },

            _addAgentGroupSection: function(options) {
                options = options || {};
                var skillLoadBalanceSectionModel = new SkillLoadBalanceSectionModel();
                if (this.priority) {
                    skillLoadBalanceSectionModel.setPriority(this.priority);
                } else if(options.priority || options.priority === 0) {
                    skillLoadBalanceSectionModel.setPriority(options.priority);
                }
                if(options.splitPercentage || options.splitPercentage === 0) {
                    skillLoadBalanceSectionModel.setSplitPercentage(options.splitPercentage);
                }
                if(options.agentGroupId || options.agentGroupId === 0) {
                    skillLoadBalanceSectionModel.setAgentGroupId(options.agentGroupId);
                }
                this.loadBalanceCollection.add(skillLoadBalanceSectionModel);
            },

            _bindEvents: function() {
                this.listenTo(this.channel.vent, "loadBalance:delete", this.deleteLoadBalance);
                this.listenTo(this.channel.vent, "loadBalance:change:splitPercentage", this._loadBalanceSplitPercentageChanged);
                this.listenTo(this.channel.vent, "loadBalance:change:agentGroupId", this._loadBalanceAgentGroupIdChanged);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return  SkillLoadBalanceController;
});
